/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import React from 'react';

// EPOD Phase 4 - AL Review (Action 16) brought inline into epodScreen.js's own grid, so an
// Enmovil/AL admin can view a dealer's submitted NDV and approve/reject it without navigating to
// the separate /alReview screen. Follows the exact same frameworkComponent pattern already
// established by dealerConditionActions.js: reads state from props.context.componentParent
// (epodScreen) and calls back its handler methods. Renders nothing at all unless epodScreen's own
// alReviewQueueMap (sourced 1:1 from the existing /billing/alReviewQueue response, unscoped -
// AL reviews across all dealers) says this row is present. The backend independently re-validates
// everything on the actual /billing/alReviewAction call regardless of what this button shows.
//
// Button-only - the status/condition/shortage/NDV summary text lives in the separate "AL Review"
// column's own valueGetter (epodScreen.js), not here, so the two never render duplicate/competing
// content in the same cell.
const AlReviewCellAction = (props) => {
    const parent = props.context && props.context.componentParent;
    if (!parent) return null;

    const qrow = (parent.state.alReviewQueueMap || {})[String(props.data._id)];
    if (!qrow || qrow.dealer_confirmation_status !== 'pending_al_review') return null;

    return (
        <button className="btn btn-primary" style={{ padding: '2px 8px', fontSize: '12px' }}
            onClick={(e) => { e.stopPropagation(); parent.onClickAlReview(qrow); }}>
            Review
        </button>
    );
};

export default AlReviewCellAction;
